<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Detalle de stock</h2>
          <p>
            El producto {{ stockDetails | formatStockProductDetails }} tiene
            actualmente {{ stockDetails.quantity }} unidades en stock en la
            tienda de {{ stockDetails.location.name }}.
          </p>
          <h3>Histórico de variaciones</h3>
          <v-server-table
            :url="table.url"
            ref="table"
            :columns="table.columns"
            :options="table.options"
          >
            <div slot="h__checkbox">
              <b-form-checkbox
                v-model="table.allSelected"
                @change="toggleAll"
              />
            </div>

            <div slot="checkbox" slot-scope="props">
              <b-form-checkbox
                :checked="table.selected.includes(props.row.reference)"
                @change="toggleCell($event, props.row.reference)"
              />
            </div>

            <template v-slot:quantity="props">
              <span
                >{{ props.row.quantity > 0 ? '+' : '' }}{{ props.row.quantity }}
              </span>
            </template>

            <template v-slot:abbr_product_name="props">
              {{
                props.row.product
                  ? `${props.row.product.reference} (${props.row.product.id})`
                  : `${props.row.predefined_product.reference} (${props.row.predefined_product.id})`
              }}
            </template>

            <template v-slot:created_at="props">
              <span>{{ props.row.created_at }}</span>
            </template>

            <template v-slot:total_price="props">
              <span>{{ props.row.total_price }} €</span>
            </template>

            <template v-slot:created_by="props">
              <span>{{
                props.row.employee_first_name
                  ? props.row.employee_first_name
                  : '-'
              }}</span>
            </template>

            <template v-slot:orders="props">
              <div :key="order" v-for="order in props.row.order_set">
                <b-link
                  :to="{
                    name: 'AdminOrdersEditScreen',
                    params: { id: order },
                  }"
                  >{{ order }}
                </b-link>
              </div>
            </template>

            <template v-slot:actions="props">
              <b-button-group>
                <b-button
                  :to="{
                    name: 'AdminStockLinesEditScreen',
                    params: { id: props.row.id },
                  }"
                  size="sm"
                  variant="outline-primary"
                  ><b-icon icon="eye-fill" aria-hidden="true" /> /
                  <b-icon icon="pencil" aria-hidden="true" />
                </b-button>
              </b-button-group>
            </template>
          </v-server-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  decimal,
  requiredIf,
} from 'vuelidate/lib/validators';
import ProductModal from '@/admin/components/quotes/ProductModal.vue';
import PredefinedProductModal from '@/admin/components/quotes/PredefinedProductModal.vue';

import FreeTextProductModal from '@/admin/components/quotes/FreeTextProductModal.vue';
import SubtitleModal from '@/admin/components/quotes/SubtitleModal.vue';

import AdminCustomersEditScreen from '@/admin/screens/customers/AdminCustomersEditScreen.vue';

import { actions, uris } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import * as Sentry from '@sentry/browser';
import Multiselect from 'vue-multiselect';

export default {
  name: 'AdminStockLinesEditScreen',
  props: ['id'],

  components: {
    Multiselect,
    ProductModal,
    PredefinedProductModal,
    FreeTextProductModal,
    AdminCustomersEditScreen,
    SubtitleModal,
  },
  mixins: [validationMixin],
  validations() {
    let rules = {
      customer: {
        required,
      },
      // billingAddress: {
      //   required,
      // },
      shippingMethod: {
        required,
      },
      location: {
        required,
      },
      shippingAddress: {},
      manual_numeration: {},
      productPricesInclTax: {
        required,
      },
      productPricesExclTax: {
        required,
      },
      productDiscounts: {},
      productDiscountsAbsolute: {},
      discountType: {
        required,
      },
      discount: {
        required,
      },
      discountPct: {
        required,
      },
      totalPriceProductsInclTax: {
        required,
      },
      totalPriceProductsExclTax: {
        required,
      },
      shippingPrice: {
        required,
      },
      taxPrice: {
        required,
      },
      amtPaid: {
        required,
      },
      amtPaidCredit: {
        required,
      },
      amtPaidTransfer: {
        required,
      },
      amtPaidCash: {
        required,
      },
      products: {
        $each: {
          reference: {
            required,
          },
          attributes: {
            $each: {
              selector_inputs: {
                required,
              },
              extra_info: {},
              label: {
                required,
              },
              reference: {
                // Empty for predefined products
              },
            },
          },
          description: {},
          comments: {},
          subtitle: {},
          images: {
            $each: {},
          },
          quantity: {
            required,
          },
          type: {
            required,
          },
        },
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    return {
      sharedState: store.state,
      table: {
        url: uris.stockChangesURI(this.id),
        selected: [],
        allSelected: false,
        columns: ['description', 'quantity', 'created_at'],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            abbr_product_name: 'Producto',
            quantity: 'Variación',
            description: 'Descripción',
            created_at: 'Fecha',
          },
        },
      },
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      stockDetails: null,
    };
  },
  computed: {
    pendingAmt() {
      return (
        this.totalPrice -
        parseFloat(this.form.amtPaidCredit ? this.form.amtPaidCredit : '0.00') -
        parseFloat(
          this.form.amtPaidTransfer ? this.form.amtPaidTransfer : '0.00'
        ) -
        parseFloat(this.form.amtPaidCash ? this.form.amtPaidCash : '0.00')
      );
    },
    totalPrice() {
      return (
        parseFloat(this.form.totalPriceProductsInclTax) -
        parseFloat(this.form.discount) +
        parseFloat(this.form.shippingPrice)
      );
    },
  },
  created() {
    console.log(this.id);
    // this.productsMultiselect.isLoading = true;

    let promises = [];
    promises.push(actions.getStockLine(this.id));

    Promise.all(promises).then((x) => {
      this.stockDetails = x[0].data;
    });
  },
  filters: {
    formatStockProductDetails: function (stockLineData) {
      if (stockLineData.product) {
        // Product
        return stockLineData.product.reference;
      } else if (stockLineData.predefined_product) {
        // Predefined
        return stockLineData.predefined_product.reference;
      } else {
        console.log('JALO', stockLineData);
        return `${stockLineData.product_attributes.reference} ${
          stockLineData.product_attributes.description
            ? `(${stockLineData.product_attributes.description})`
            : ''
        } `;
        // Free text
      }
    },
    formatBillingAddress: function (billingAddress) {
      const {
        first_name,
        last_name,
        street_address,
        postal_code,
        city,
        country,
        company_name,
        company_id,
      } = billingAddress;

      let lines = [];
      lines.push(`${first_name} ${last_name}`);
      lines.push(`${street_address}`);
      lines.push(`${city} (${postal_code})`);
      lines.push(`${country}`);

      return lines;
    },
  },
  methods: {
    payWithCredit() {
      this.form.amtPaidCredit = this.totalPrice.toFixed(2);
      this.form.amtPaidTransfer = '0.0';
      this.form.amtPaidCash = '0.0';
    },
    payWithTransfer() {
      this.form.amtPaidTransfer = this.totalPrice.toFixed(2);
      this.form.amtPaidCredit = '0.0';
      this.form.amtPaidCash = '0.0';
    },
    payWithCash() {
      this.form.amtPaidCash = this.totalPrice.toFixed(2);
      this.form.amtPaidCredit = '0.0';
      this.form.amtPaidTransfer = '0.0';
    },
    isStockAvailable(i) {
      let availableStock = this.form.productStocks[i][this.location];
      let productQuantity = this.form.products[i].quantity;

      return availableStock >= productQuantity;
    },

    changeProductDiscount(i, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.form.productDiscounts[i] = val;

      this.quotePrice();
    },
    swapProducts(i, j) {
      this.form.products[i] = this.form.products.splice(
        j,
        1,
        this.form.products[i]
      )[0];
      this.form.productPricesInclTax[i] = this.form.productPricesInclTax.splice(
        j,
        1,
        this.form.productPricesInclTax[i]
      )[0];
      this.form.productPricesExclTax[i] = this.form.productPricesExclTax.splice(
        j,
        1,
        this.form.productPricesExclTax[i]
      )[0];

      this.form.productHashes[i] = this.form.productHashes.splice(
        j,
        1,
        this.form.productHashes[i]
      )[0];

      this.form.productStocks[i] = this.form.productStocks.splice(
        j,
        1,
        this.form.productStocks[i]
      )[0];

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts[i] = this.form.productDiscounts.splice(
          j,
          1,
          this.form.productDiscounts[i]
        )[0];

        this.form.productDiscountsAbsolute[
          i
        ] = this.form.productDiscountsAbsolute.splice(
          j,
          1,
          this.form.productDiscountsAbsolute[i]
        )[0];
      }
    },
    moveUp(i) {
      i = parseInt(i);
      this.swapProducts(i, i - 1);
    },
    moveDown(i) {
      i = parseInt(i);
      this.swapProducts(i, i + 1);
    },
    orderedProductImagesArr(productImages) {
      let arr = [];
      for (let index = 0; index < Object.keys(productImages).length; index++) {
        const element = Object.keys(productImages).reverse()[index];
        arr.push(productImages[element].$model);
      }
      return arr;
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    setDecimalProduct(i, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.products.$each.$iter[i][name].$model = val;
      this.$v.form.products.$each.$iter[i][name].$touch();
      this.quotePrice();
    },
    customerAdded(idCustomer) {
      actions.getCustomersUnpaginated().then((response) => {
        this.customersMultiselect.loadedOptions = response.data.results.map(
          (x) => {
            return {
              text:
                x.last_name +
                ' ' +
                x.first_name +
                (x.email ? ' (' + x.email + ')' : ''),
              value: x.id,
            };
          }
        );

        this.customersMultiselect.isLoading = false;
        this.form.customer = this.customersMultiselect.loadedOptions.find(
          (x) => x.value === idCustomer
        );
        this.showNewCustomerModal = false;
      });
    },
    newCustomerModal() {
      this.showNewCustomerModal = true;
    },

    changedDiscount() {
      if (!this.form.shippingMethod) {
        return false;
      }
      this.quotePrice(false /*, true*/);
    },
    quotePrice(
      onlyUpdateShippingPrice = false /*, onlyUpdateDiscount = false*/
    ) {
      let data = {};

      data['customer'] = this.form.customer.value;
      data['billing_address'] = this.form.billingAddress;
      data['shipping_address'] = this.form.shippingAddress;

      data['shipping_method'] = this.form.shippingMethod;
      data['products'] = this.form.products;

      data['discount_pct'] = this.form.discountPct;

      data['product_discounts'] = this.form.productDiscounts;

      actions.postQuotePrice(data).then((x) => {
        // if (onlyUpdateDiscount) {
        //   this.form.discount = x.data.discount;
        //   this.form.taxPrice = x.data.taxPrice;
        // } else
        if (!onlyUpdateShippingPrice) {
          this.form.productPricesInclTax = x.data.productPricesInclTax;
          this.form.productPricesExclTax = x.data.productPricesExclTax;
          this.form.productDiscountsAbsolute = x.data.productDiscountsAbsolute;

          this.form.discount = x.data.discount;

          this.form.totalPriceProductsInclTax =
            x.data.totalPriceProductsInclTax;

          this.form.totalPriceProductsExclTax =
            x.data.totalPriceProductsExclTax;

          this.form.taxPrice = x.data.taxPrice;

          this.form.productHashes = x.data.productHashes;
          this.form.productStocks = x.data.productStockAvailability;

          if (this.$v.form.shippingMethod.$model !== 6) {
            this.form.shippingPrice = x.data.shippingPrice.toFixed(2);
          }
        } else {
          if (this.$v.form.shippingMethod.$model !== 6) {
            this.form.shippingPrice = x.data.shippingPrice.toFixed(2);
          }
        }
      });
    },
    cancelAddProduct() {
      this.showModal = false;
    },
    editSubtitle(subtitle) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        subtitle: subtitle,
        type: 'subtitle',
      });

      this.showSubtitleModal = false;
    },

    addSubtitle(subtitle) {
      this.showSubtitleModal = false;

      this.form.products.push({
        subtitle: subtitle,
        type: 'subtitle',
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();
    },

    deleteArticle(articleIndex) {
      const name = this.form.products[articleIndex].reference;

      if (
        confirm(
          '¿Estás seguro que deseas quitar el producto ' +
            name +
            ' del presupuesto?'
        )
      ) {
        this.form.products.splice(articleIndex, 1);
        this.quotePrice();
      }
    },
    editArticle(articleIndex) {
      //if ()
      this.selectedProductID = this.form.products[articleIndex].id.toString();

      if (this.form.products[articleIndex].type === 'predefined') {
        this.selectedProductID = 'PRE_' + this.selectedProductID;
      }

      this.selectedProductData = this.form.products[articleIndex];
      this.articleCurrentIndex = articleIndex;

      if (this.selectedProductID === '0') {
        this.showFreeArticleModal = true;
      } else {
        this.showModal = true;
      }
    },
    duplicateArticle(articleIndex) {
      const newProduct = JSON.parse(
        JSON.stringify(this.form.products[articleIndex])
      );

      this.form.products.splice(articleIndex, 0, newProduct);

      this.form.productPricesInclTax.splice(
        articleIndex,
        0,
        this.form.productPricesInclTax[articleIndex]
      );

      this.form.productPricesExclTax.splice(
        articleIndex,
        0,
        this.form.productPricesExclTax[articleIndex]
      );

      this.quotePrice();
    },
    addFreeTextArticleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showFreeArticleModal = true;
    },
    addSubtitleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showSubtitleModal = true;
    },
    addArticleToQuoteBtn() {
      this.selectedProductID = this.form.product.value.toString();

      this.selectedProductData = null;

      this.showModal = true;
    },
    discountTypeChanged(val) {
      if (val === 'Per-product') {
        let arr = [];
        for (let index = 0; index < this.form.products.length; index++) {
          arr.push('0');
        }

        this.form.productDiscounts = arr;
        this.form.productDiscountsAbsolute = arr;

        this.form.discountPct = '0';
        this.form.discount = 0;
      } else {
        this.form.discountPct = '0';
        this.form.discount = 0;
      }
    },
    shippingMethodChanged(val) {
      if (![3, 4, 5, 6, 7].includes(this.$v.form.shippingMethod.$model)) {
        this.$v.form.shippingAddress.$model = null;
      } else if (
        [3, 4, 5, 6, 7].includes(this.$v.form.shippingMethod.$model) &&
        this.form.shippingAddress === null &&
        this.shippingAddressSelect.loadedOptions.length > 0
      ) {
        this.$v.form.shippingAddress.$model = this.shippingAddressSelect.loadedOptions[0].value;
      }

      this.quotePrice(true);
    },
    billingAddressSelectChanged(val) {
      actions.getBillingAddress(val).then((z) => {
        this.billingAddressSelect.selectedAddress = z.data;
      });
    },
    customersMultiselectChanged(selectedOption, id) {
      this.setDecimal(
        'discountPct',
        selectedOption.default_discount.replace('.', ',')
      );
      this.changedDiscount();

      actions.getBillingAddressesByCustomer(selectedOption.value).then((y) => {
        this.billingAddressSelect.loadedOptions = y.data.results.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      });

      actions.getShippingAddressesByCustomer(selectedOption.value).then((y) => {
        this.shippingAddressSelect.loadedOptions = y.data.results.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      });
    },
    asyncFindCustomers(query) {
      this.customersMultiselect.isLoading = true;
      actions.getCustomersGlobalSearch(query).then((response) => {
        this.customersMultiselect.loadedOptions = response.data.results.map(
          (x) => {
            return {
              text:
                x.last_name +
                ' ' +
                x.first_name +
                (x.email ? ' (' + x.email + ')' : ''),
              value: x.id,
              default_discount: x.default_discount,
            };
          }
        );
        this.customersMultiselect.isLoading = false;
      });
    },

    asyncFindProducts(query) {
      this.productsMultiselect.isLoading = true;

      let promises = [];
      promises.push(actions.getProductsGlobalSearch(query));
      promises.push(actions.getPredefinedProductsGlobalSearch(query));

      Promise.all(promises).then((response) => {
        let arr = [];

        arr = [
          ...arr,
          ...response[0].data.results.map((x) => {
            return {
              text: '(' + x.id + ') ' + x.reference,
              value: x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        arr = [
          ...arr,
          ...response[1].data.results.map((x) => {
            return {
              text: '(' + x.id + ') ' + x.reference,
              value: 'PRE_' + x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        this.productsMultiselect.loadedOptions = arr;

        this.productsMultiselect.isLoading = false;
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateProduct(index, field) {
      const { $dirty, $error } = this.$v.form.products.$each[index][field];
      return $dirty ? !$error : null;
    },
    getFormData() {
      let data = {};

      data['customer'] = this.form.customer.value;
      data['billing_address'] = this.form.billingAddress;
      data['shipping_address'] = this.form.shippingAddress;

      data['shipping_method'] = this.form.shippingMethod;
      data['products'] = this.form.products;

      data['manual_numeration'] = this.form.manual_numeration;

      data['product_prices_incl_tax'] = this.form.productPricesInclTax;
      data['product_discounts'] = this.form.productDiscounts;
      data['product_discounts_absolute'] = this.form.productDiscountsAbsolute;
      data['discount_type'] = this.form.discountType;

      data['product_prices_excl_tax'] = this.form.productPricesExclTax;

      data['discount_pct'] = this.form.discountPct;
      data['discount'] = this.form.discount.toFixed(4);

      data['tax_price'] = this.form.taxPrice.toFixed(4);

      data[
        'totalprice_products_incl_tax'
      ] = this.form.totalPriceProductsInclTax.toFixed(4);
      data[
        'totalprice_products_excl_tax'
      ] = this.form.totalPriceProductsExclTax.toFixed(4);

      data['product_hashes'] = this.form.productHashes;
      data['product_stocks'] = this.form.productStockAvailability;

      data['shipping_price'] = this.form.shippingPrice;

      data['total_price'] = this.totalPrice.toFixed(2);

      data['location'] = this.form.location;

      return data;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = this.getFormData();

      Sentry.setExtra('data', JSON.stringify(data));

      if (this.id !== 'new') {
        actions.patchQuote(this.id, data).then((x) => {
          this.$router.push({ name: 'AdminQuotesScreen' });
        });
      } else {
        actions.postQuote(data).then((x) => {
          this.$router.push({ name: 'AdminQuotesScreen' });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.subtitle {
  background-color: #f3f3f3;
  border: lightgray 1px solid;
  border-radius: 0.25rem;
  padding: 0.5rem;
  text-align: center;
}
.uniqueImg {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
.leftImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}
.rightImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 2rem;
  left: 2rem;
}

.comments {
  margin-top: 0.2rem;
  font-style: italic;
}

.gray-text {
  display: block;
  color: gray;
}

.stock {
  white-space: pre-wrap;
  &.available {
    color: green;
  }
  &.unavailable {
    color: red;
  }
}

ol {
  list-style-type: circle;
  li {
    margin-left: 2rem;
  }
}
</style>
